export const featureFlags = {
  payment: 'payment' as const,
  goLinks: 'goLinks' as const,
  turnstile: 'turnstile' as const,
  validateStripeEmailDomain: 'validateStripeEmailDomain' as const,
  myinfoSgid: 'myinfo-sgid' as const,
  chartsMaxResponseCount: 'charts-max-response-count' as const,
  addingTwilioDisabled: 'adding-twilio-disabled' as const,
}
